import React from "react";
import "./Error.css";

const Error = () => {
	return <h1 className="error-section">Error: Cannot find requested page (╯°益°)╯彡┻━┻</h1>;
};

export default Error;
